export const LOGO_MSG = 'Go back to the homepage.';
